import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { SupabaseService } from '../services/supabase.service';

/// <summary>
/// Guard that protects routes requiring authentication with Supabase
/// </summary>
@Injectable({
  providedIn: 'root'
})
export class SupabaseAuthGuard implements CanActivate {
  
  constructor(
    private supabaseService: SupabaseService,
    private router: Router
  ) {}

  /// <summary>
  /// Determines if a route can be activated based on authentication status
  /// </summary>
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    // Wait for initial session to load, then check authentication
    return this.supabaseService.initialSessionLoaded$.pipe(
      filter(loaded => loaded === true),  // Wait until session is actually loaded
      take(1),
      map(() => {
        const isAuthenticated = this.supabaseService.isAuthenticated;
        
        if (!isAuthenticated) {
          console.log('User not authenticated, redirecting to login');
          this.router.navigate(['/login'], {
            queryParams: { returnUrl: state.url }
          });
        }
        
        return isAuthenticated;
      })
    );
  }
}
